// api-admin-app-std request timeout is 60s. Fail the client slightly sooner so
// React Query gets a clean timeout instead of hanging until the gateway drops
// the connection, and so we do not stack retries on a known-slow path. The
// gateway's own 504 carries no CORS headers, so the browser hides its status.
export const ADMIN_API_REQUEST_TIMEOUT_MS = 55_000;
